import * as R from 'ramda';
import { REQUIRED } from 'utils/helpers/validationMessages';

const MAX_VOLUME_DIGITS = 14;

export const requiredError = R.ifElse(
  R.either(R.isNil, R.isEmpty),
  R.always(REQUIRED),
  R.always('')
);

export const maxLengthError = (value, max) =>
  R.defaultTo('', value).length > max ? `Cannot exceed ${max} characters` : '';

export const sanitizeVolume = value =>
  R.defaultTo('', value)
    .replace(/\D/g, '')
    .replace(/^0+(?=\d)/, '');

export const volumeError = value => {
  if (R.isNil(value) || R.isEmpty(value) || Number(value) <= 0) {
    return REQUIRED;
  }
  return String(value).length > MAX_VOLUME_DIGITS
    ? `Cannot exceed ${MAX_VOLUME_DIGITS} digits`
    : '';
};

// Fields compared against their fetched originals to determine the Customer Info "unsaved changes" indicator
export const CUSTOMER_INFO_FIELD_KEYS = [
  'address',
  'address2',
  'authorizationType',
  'authorizationVolume',
  'city',
  'customerName',
  'phoneNumber',
  'renewalVolume',
  'state',
  'zipCode',
];
